import { Suspense, lazy } from 'react';

import { HeroPatternNew } from '@/components/hero-pattern';

// Imported per-file rather than via the barrel: the barrel re-exports the
// lazy sections below, and their module graphs have top-level side effects
// that defeat tree-shaking, which would pull them back into the eager chunk.
import { SectionBrandLogos } from '@/pages/unauthenticated/landing-page/components/section.brand-logos';
import { SectionCli } from '@/pages/unauthenticated/landing-page/components/section.cli';
import { SectionHero } from '@/pages/unauthenticated/landing-page/components/section.hero';
import { SectionPricing } from '@/pages/unauthenticated/landing-page/components/section.pricing';
import { SectionStats } from '@/pages/unauthenticated/landing-page/components/section.stats';

// These two sections showcase real dashboard components (charts, targeting
// forms) that drag recharts/react-select into the bundle. They're below the
// fold, so they get their own chunk: prerendered HTML still includes them
// (prerender awaits all Suspense boundaries), and hydration fills in when
// the chunk arrives.
const SectionExperiments = lazy(() =>
  import('@/pages/unauthenticated/landing-page/components/section.experiments').then(
    (m) => ({ default: m.SectionExperiments }),
  ),
);
const SectionWhyFlagsync = lazy(() =>
  import('@/pages/unauthenticated/landing-page/components/section.why-flagsync').then(
    (m) => ({ default: m.SectionWhyFlagsync }),
  ),
);
import {
  Navigation,
  SectionFooter,
  SectionReadyToRelease,
  SignInOrDashboard,
} from '@/pages/unauthenticated/components';

export default function Home() {
  return (
    <>
      <Navigation>
        <SignInOrDashboard />
      </Navigation>
      <main>
        <HeroPatternNew className="isolate lg:top-132" />
        <SectionHero />
        <SectionBrandLogos />
        <SectionCli />
        <SectionStats />
        <Suspense fallback={null}>
          <SectionExperiments />
          <SectionWhyFlagsync />
        </Suspense>
        <SectionPricing />
        <SectionReadyToRelease />
        <SectionFooter />
      </main>
    </>
  );
}
